import { Dialog, DialogContent } from '@mui/material';
import { MprcDialogTitleClose } from 'components';
import { DiscussionListFilter } from 'generated/CoreApi_v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EnrollmentViewAbout } from '../Shared/EnrollmentViewAbout';

/////////////////////////////////////////////////////////////////////////////////////

const aboutTabs = ["overview", "discussion", "notices"] as const;

export type LpEnrollmentViewAboutTabs = (typeof aboutTabs)[number];

export function isOfTypeLpEnrollmentViewAboutTabs(value: string): value is LpEnrollmentViewAboutTabs {
    return (aboutTabs as readonly string[]).includes(value);
}

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    aboutTab: LpEnrollmentViewAboutTabs;
    initialDiscussionFilter?: DiscussionListFilter;
    onClose: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const LpEnrollmentViewAbout: React.FC<IProps> = ({ aboutTab, initialDiscussionFilter = DiscussionListFilter.All, onClose }) => {

    const { t } = useTranslation("lms");

    return (
        <Dialog
            open
            fullWidth
            maxWidth="md"
            onClose={onClose}
        >
            <MprcDialogTitleClose
                title={t("Student.EnrollmentView.LearnPath.AboutTitle")}
                onClose={onClose}
                shrinkPadding
            />
            <DialogContent>
                <EnrollmentViewAbout
                    openOnTab={aboutTab}
                    discussionFilter={initialDiscussionFilter}
                />
            </DialogContent>
        </Dialog>
    );
};
